import { AuthSelectors, ObFlowService } from '@web_opxp/features';
import { useTranslation } from '@web_opxp/language';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { HistoryService } from 'web_core_library';
import { isCustomObFlowActive, isSubscribe } from './utils';

export default function useRedirect() {
  const sessionToken = useSelector(AuthSelectors.getToken);
  const { language } = useTranslation();
  const location = useLocation();
  // this redirect must also support ob_flow in case flow is active
  const redirectToTraining = useCallback(() => {
    const isOnSubscribePage = isSubscribe(location.pathname);
    const obFlowActive = isCustomObFlowActive();
    if (isOnSubscribePage && obFlowActive) {
      return ObFlowService.redirectToNextObStep('subscribe', language, sessionToken);
    }
    return HistoryService.redirectToTraining(language, sessionToken);
  }, [language, location, sessionToken]);
  return { redirectToTraining };
}
